module.exports = __webpack_public_path__ + "static/media/user_2.1e71bd65.png";